import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { has } from 'lodash';

import { Enums } from '../../../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-fixed-planed-schedule-modal',
  templateUrl: './fixed-planed-schedule-modal.component.html',
  styleUrls: ['./fixed-planed-schedule-modal.component.scss'],
  standalone: false,
})
export class FixedPlanedScheduleModalComponent implements OnInit {
  private data: any;
  public moment = require('moment');
  public successActionLoading: boolean;
  public errorMessage: string | null;
  private successCallbackAction;
  public title: string;
  public description: string;
  public successButtonName: string;
  public abortButtonName: string;
  public currentDate: string;
  public countNextMonthForFixed: number;
  public fixedDate: string;
  public isBlockedFixed: boolean;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.countNextMonthForFixed = 1;

    let countNextMonthForFixedDateMillis = +this.moment(this.currentDate).add(this.countNextMonthForFixed, 'month').endOf('month');
    let fixedMonthDateMillis = +this.moment(this.fixedDate);

    if (fixedMonthDateMillis > countNextMonthForFixedDateMillis) {
      this.errorMessage = 'Фиксация графика дальше следующего месяца – невозможна';
      this.isBlockedFixed = true;
    } else {
      this.errorMessage = null;
      this.isBlockedFixed = false;
    }
  }

  successAction() {
    this.errorMessage = null;
    this.successActionLoading = true;

    this.successCallbackAction(this.data).subscribe(
      (response) => {
        this.activeModal.close();
        this.successActionLoading = false;
      },
      (error) => {
        if (has(error, 'error.metadata.code') && error.error.metadata.code === 100050) {
          this.errorMessage = 'Фиксация графика дальше следующего месяца – невозможна';
        } else {
          this.errorMessage = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
        }

        this.successActionLoading = false;
      }
    );
  }
}
